import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
import { CharacterChangesSchema } from "../../CharacterChanges";
export const CharacterChangesBladeSchema = BladeCommonSchema.extend({
    title: z.string().optional(),
    characters: z.array(CharacterChangesSchema),
});
//# sourceMappingURL=index.js.map